import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResumeService {

  // modificar
  resume: any = {
    universidad: 'Universidad Nacional José Faustino Sánchez Carrión',
    periodo: '2014 II - 2019 I',
    escuela: 'Escuela Académico Profesional Ingeniería de Sistemas',
    ubicacionUni: ' Huacho - Perú.',
    instituto: 'Instituto de idiomas UNJFSC',
    nivelIngles:'Nivel Básico',
    periodoIns: 'enero 2019 – julio 2019',
    resumen: 'Desarrollador de Aplicaciones Web, aplicando tecnologías modernas en base a requerimientos del usuario.',
  };
  experiencias:any =[
    {
      empresa:'ERP SYSTEMS & SOLUTIONS S.A.C.',
      area:'Desarrollo',
      cargo:'Desarrollador FullStack',
      actividad:'Desarrollo Web de un sistema ERP. Desarrollado en lenguaje JavaScript, NodeJs, Html, Css, Consumo de ApiRest, Angular, TypeScript',
      fechaIngreso:'01/01/2020',
      fechaSalida:'Presente',
    },
    {
      empresa:'Biblioteca Central - UNJFSC',
      area:'Sistemas',
      cargo:'Practicante de sistemas',
      actividad:'Desarrollo de un sistema de control de entrega y recepcion de libros, revistas y otros. Desarrollado en el lenguaje PHP, HTML, CSS JAVASCRIPT',
      fechaIngreso:'01/07/2019',
      fechaSalida:'31/12/2019',
    },
    {
      empresa:'Instituto de idiomas - UNJFSC.',
      area:'Sistemas',
      cargo:'Practicante de sistemas.',
      actividad:'Se realizo le mantenimiento del sistema de escritorio de regirto de asistencias y notas de los cursos. Desarrollado en el lenguaje de C#',
      fechaIngreso:'01/04/2019',
      fechaSalida:'30/06/2019',
    },
  ]

  constructor() { }
}
